export default __webpack_public_path__ + "static/media/iconHomeBookActive.1938a42c.svg";